/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type Permission = (typeof Permission)[keyof typeof Permission];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Permission = {
  NotSet: "NotSet",
  Home: "Home",
  DispositiviRead: "DispositiviRead",
  DispositiviReadAll: "DispositiviReadAll",
  DispositiviUpdateTrasferimenti: "DispositiviUpdateTrasferimenti",
  DispositivoCreate: "DispositivoCreate",
  DispositivoUpdate: "DispositivoUpdate",
  DispositivoGeneraCertificato: "DispositivoGeneraCertificato",
  DispositivoDelete: "DispositivoDelete",
  DispositiviReadManutenzioni: "DispositiviReadManutenzioni",
  DispositiviUpdateManutenzioni: "DispositiviUpdateManutenzioni",
  DispositivoRegistriRead: "DispositivoRegistriRead",
  DispositivoRegistriWrite: "DispositivoRegistriWrite",
  DispositiviDatiStoriciRead: "DispositiviDatiStoriciRead",
  DispositiviDatiStoriciReadAll: "DispositiviDatiStoriciReadAll",
  DispositiviAlertValuesEdit: "DispositiviAlertValuesEdit",
  DispositiviAlertInternalUserOptionsEdit:
    "DispositiviAlertInternalUserOptionsEdit",
  DispositiviUpdateReminders: "DispositiviUpdateReminders",
  AziendeReadAll: "AziendeReadAll",
  AziendeRead: "AziendeRead",
  AziendaRead: "AziendaRead",
  AziendaCreate: "AziendaCreate",
  AziendaUpdate: "AziendaUpdate",
  AziendaEdit: "AziendaEdit",
  AziendaDelete: "AziendaDelete",
  ContenitoriRead: "ContenitoriRead",
  ContenitoriReadAll: "ContenitoriReadAll",
  ContenitoreCreate: "ContenitoreCreate",
  ContenitoreUpdate: "ContenitoreUpdate",
  ContenitoreUpdateAlloggiamentiFiltro: "ContenitoreUpdateAlloggiamentiFiltro",
  ContenitoreUpdateStoricoFiltri: "ContenitoreUpdateStoricoFiltri",
  ContenitoreUpdateStoricoOlio: "ContenitoreUpdateStoricoOlio",
  ContenitoreUpdateReminders: "ContenitoreUpdateReminders",
  ContenitoreUpdateBonifica: "ContenitoreUpdateBonifica",
  ContenitoreUpdateAnalisi: "ContenitoreUpdateAnalisi",
  ContenitoreUpdateFiltrazioni: "ContenitoreUpdateFiltrazioni",
  ContenitoreUpdateImmagini: "ContenitoreUpdateImmagini",
  ContenitoreDelete: "ContenitoreDelete",
  GatewayRead: "GatewayRead",
  GatewayReadAll: "GatewayReadAll",
  GatewayCreate: "GatewayCreate",
  GatewayUpdate: "GatewayUpdate",
  GatewayDelete: "GatewayDelete",
  RipetitoreRead: "RipetitoreRead",
  RipetitoreReadAll: "RipetitoreReadAll",
  RipetitoreCreate: "RipetitoreCreate",
  RipetitoreUpdate: "RipetitoreUpdate",
  RipetitoreDelete: "RipetitoreDelete",
  GrafoRead: "GrafoRead",
  GrafoUpdate: "GrafoUpdate",
  TrasferimentiChange: "TrasferimentiChange",
  ConnessioneGatewayChange: "ConnessioneGatewayChange",
  UsersInterniRead: "UsersInterniRead",
  UsersEsterniRead: "UsersEsterniRead",
  UsersInterniChange: "UsersInterniChange",
  UsersEsterniChange: "UsersEsterniChange",
  ModelliFiltroChange: "ModelliFiltroChange",
  ModelliOlioChange: "ModelliOlioChange",
  ModelliGatewayChange: "ModelliGatewayChange",
  DescrizioniBonificaChange: "DescrizioniBonificaChange",
  DescrizioniManutenzioneChange: "DescrizioniManutenzioneChange",
  ModelliDispositivoChange: "ModelliDispositivoChange",
  NodoIconeChange: "NodoIconeChange",
  FileUpload: "FileUpload",
  AnalisiListaReadAll: "AnalisiListaReadAll",
  AnalisiListaRead: "AnalisiListaRead",
  FiltrazioniListaReadAll: "FiltrazioniListaReadAll",
  FiltrazioniListaRead: "FiltrazioniListaRead",
  BonificheListaReadAll: "BonificheListaReadAll",
  BonificheListaRead: "BonificheListaRead",
  CalendarioInterventiRead: "CalendarioInterventiRead",
  CalendarioTrasferimentiRead: "CalendarioTrasferimentiRead",
  RuoliPermessiRead: "RuoliPermessiRead",
  RuoliPermessiUpdate: "RuoliPermessiUpdate",
  RichiestePreventivoRead: "RichiestePreventivoRead",
  RichiestePreventivoReadAll: "RichiestePreventivoReadAll",
  RichiestePreventivoUpdate: "RichiestePreventivoUpdate",
  RichiestePreventivoDelete: "RichiestePreventivoDelete",
} as const;
